import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Container,
  Row,
  Image,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import {
  addReviewForProperty,
  cancelBookingUser,
  MyBooking,
} from "../../../utility/apiServices/userServices";
import Swal from "sweetalert2";
import { formatDate } from "../../userpanel/propertydetail";
import LoaderHome from "../../../components/loader/homeloader";
import { format, isBefore } from "date-fns";
import { DateRangePicker } from "react-date-range";
import { useTranslation } from "react-i18next";
import { description } from "../../../utility/local/functions/crypto";

const MyBookings = () => {
  const { t, i18n } = useTranslation();

  const [searchText] = useState("");
  const dateRangePickerRef = useRef();
  const [propertyData, setpropertyData] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [bookingIdd, setBookingId] = useState("")
  const [reviewmodalShow, setreviewmodalShow] = useState(false);
  const [reviewPropertyId, setreviewPropertyId] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(null)
  const currentLanguage = i18n.language;

  const paginationOptions = {
    rowsPerPageText: t("rowsPerPage"),
    rangeSeparatorText: t("of"), 
  };

  const [selectionRange, setSelectionRange] = useState({
    startDate: "",
    endDate: "",
    key: "selection",
  });
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);

  const bookings = async () => {
    const response = await MyBooking({
      startDate: selectionRange?.startDate
        ? format(selectionRange.startDate, "yyyy-MM-dd")
        : "",
      endDate: selectionRange.endDate
        ? format(selectionRange.endDate, "yyyy-MM-dd")
        : "",
      page,
      limit
    },

    );
    if (response?.status) {
      setpropertyData(response?.bookings);
      setTotalRecords(response?.totalResults)
    } else {
      Swal.fire({
        icon: "error",
        text: response?.message,
      });
    }
    setisDataLoading(false);
  };

  useEffect(() => {
    setisDataLoading(true);
    bookings();
  }, [selectionRange, page, limit]);

  const updateBookingStatus = (bookingId, newStatus) => {
    setpropertyData((prevData) =>
      prevData.map((booking) =>
        booking.id === bookingId ? { ...booking, status: newStatus } : booking
      )
    );
  };

  const cancelBooking = async (bookingId) => {
    Swal.fire({
      title: t("areYouSure"),
      text: t("cancelBookingConfirmation"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
      preConfirm: async () => {
        try {
          Swal.showLoading();
          console.log("showLoading :");

          const response = await cancelBookingUser({ bookingId });
          console.log("cancelBooking :");

          return response;
        } catch (error) {
          Swal.fire({
            title: t("error"),
            text: t("errorCancellingBooking"),
            icon: "error",
            confirmButtonText: "OK",
          });
          throw error;
        }
      },
    }).then((result) => {
      if (result.isConfirmed && result.value.status) {
        Swal.fire({
          title: t("cancelledSuccess"),
          text: t("bookingCancelledSuccess"),
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          updateBookingStatus(bookingId, "cancelled");

        });
      } else if (result.isConfirmed) {
        Swal.fire({
          title: t("error"),
          text: t("errorCancellingBooking"),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  };

  const addReview = async (property_id, id) => {
    setBookingId(id)
    setreviewPropertyId(property_id);
    setreviewmodalShow(true);
  };

  const columns1 = [
    {
      name: t("bookings"),
      minWidth: "420px",
      selector: (row) => row.image,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center tb_content">
          <span className="propertytable_icon">
            <Image alt="" src={row?.Property?.images[0]?.room1[0]?.location} style={currentLanguage === "he" ? {marginLeft:"1.3rem"} :{marginRight:'1.3rem'}}/>
          </span>
          <div className="flex-grow-1">
            <h5>
              {/* {`${row?.Property?.short_description?.length > 30
              ? row?.Property?.short_description?.slice(0, 30) + "..."
              : row?.Property?.short_description
              }`} */}
              {description(row?.Property?.short_description, row?.Property?.short_description_hebrew, i18n.language)}

            </h5>
            <p>
              <Icon icon="system-uicons:location" />
              {row?.Property?.street_address?.length > 30
                ? row?.Property?.street_address.slice(0, 30) + "..."
                : row?.Property?.street_address}
            </p>
            <p className="pColor">
              {/* <Icon icon="flat-color-icons:phone" color="#5c6368" /> */}
              {row?.Property?.phone_number}
            </p>
            <h6>${row?.total_price}</h6>
          </div>
        </div>
      ),
    },
    {
      name: t("bookingDate"),
      selector: (row) => row?.start_date,
      minWidth: "200px",
      sortable: true,
      cell: (row) => {
        const isRTL = false;
        return (
          <p style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
            {isRTL ? (
              <>
                <span>{formatDate(row?.end_date)}</span> - <span>{formatDate(row?.start_date)}</span>
              </>
            ) : (
              <>
                <span>{formatDate(row?.start_date)}</span> - <span>{formatDate(row?.end_date)}</span>
              </>
            )}
          </p>
        );
      },
    },
    {
      name: t("bookedOn"),
      selector: (row) => row.end_date,
      sortable: true,
      cell: (row) => <p>{formatDate(row?.createdAt)}</p>,
    },
    {
      name: t("status"),
      selector: (row) => row?.status,
      sortable: true,
      cell: (row) => (
        <div className="d-flex flex-column align-items-center">
          {row?.status == "pending" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#cce5ff", color: "#004085" }}
              >
                {t("pending")}
              </div>
            </div>
          ) : row?.status == "accepted" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#d4edda", color: "#155724" }}
              >
                {t("confirmed")}
              </div>
            </div>
          ) : row?.status == "cancelled" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
              >
                {t("cancelled")}
              </div>
            </div>
          ) : (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
              >
                {t("rejected")}
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      name: t("actions"),
      width: "220px",
      cell: (row) => {
        const currentDate = new Date();
        const endDate = new Date(row.end_date);
        const isPastBooking = isBefore(endDate, currentDate);
        const hasReviewed = row.hasReview;


        return (
          <div>
            <div className="">
              {hasReviewed ?

                <Button
                  className="px-4"
                  style={{ height: 40, width: 175 }}
                  variant="success"
                  disabled
                >
                  {t("reviewed")}
                </Button>
                :
                row?.status === "accepted" && isPastBooking ? (
                  <Button
                    className="px-4"
                    style={{ height: 40, width: 175 }}
                    variant="primary"
                    onClick={() => {
                      addReview(row?.property_id, row?.id);
                    }}
                  >
                    {t("addReview")}
                  </Button>
                ) : row?.status === "accepted" || row?.status === "pending" ? (
                  <Button
                    className="px-4"
                    style={{ height: 40, width: 175 }}
                    variant="danger"
                    onClick={() => {
                      cancelBooking(row?.id);
                    }}
                  >
                    {t("cancelBooking")}
                  </Button>
                ) : row?.status === "cancelled" ? (
                  <Button
                    disabled={true}
                    className="px-4"
                    style={{ height: 40, width: 175 }}
                    variant="danger"
                  >
                    {t("bookingCancelled")}
                  </Button>
                ) : (
                  <Button
                    className="px-4"
                    style={{ height: 40, width: 175 }}
                    variant="danger"
                    disabled
                  >
                    {t("bookingRejected")}
                  </Button>
                )}
            </div>
          </div >
        );
      },
    }

  ];

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const handleClickOutside = (event) => {
    if (
      dateRangePickerRef.current &&
      !dateRangePickerRef.current.contains(event.target)
    ) {
      setShowDateRangePicker(false);
    }
  };

  useEffect(() => {
    if (showDateRangePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDateRangePicker]);

  return (
    <React.Fragment>
      <section className="commonpad maincontent_div">
        <Container fluid>
          <div className="proFlex proFlex1">
            <h2 className="mb-0">{t('myBookings')}</h2>
            <div  className={currentLanguage  === "he" ? "rtlFilterBnt" : 'ltrFilterBtn'} style={{ position: "relative" }}>
              <Link
                className="filterLink1"
                onClick={() => setShowDateRangePicker(!showDateRangePicker)}
              >
                {t("filterByDate")} <Icon icon="solar:calendar-bold" />
              </Link>
              {showDateRangePicker && (
                <div
                  className="date-range-container date-range-positionabs flex-column"
                  ref={dateRangePickerRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                  
                    zIndex: 1000,
                  }}
                >{
                    selectionRange && selectionRange.startDate ?
                      <DateRangePicker
                        ranges={[selectionRange]}
                        months={2}
                        onChange={handleSelect}
                        direction='vertical'
                        moveRangeOnFirstSelection={false}
                      />
                      :
                      <DateRangePicker
                        ranges={[{
                          startDate: new Date(),
                          endDate: new Date(),
                          key: "selection",
                        }]}
                        months={2}
                        onChange={handleSelect}
                        direction='vertical'
                        moveRangeOnFirstSelection={false}
                      />

                  }
                  <div className="p-2">
                    <button
                      className="close-btn btn btn-primary w-100"
                      onClick={() => setShowDateRangePicker(false)}
                    >
                      {t("filter.close")}
                    </button>
                  </div>

                </div>
              )}
            </div>
          </div>
          <Row className="g-4 mt-0">
            <Col md={12}>
              {isDataLoading ? (
                <div className="text-center d-flex justify-content-center">
                  <LoaderHome />
                </div>
              ) : (
                <DataTable
                  columns={columns1}
                  data={propertyData}
                  pagination
                  noHeader
                  responsive
                  className="tableDataTable"
                  paginationServer
                  paginationTotalRows={totalRecords}
                  paginationComponentOptions={paginationOptions}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={(newLimit) => {
                    setLimit((prev) => {
                      if (prev !== newLimit) {
                        setPage(1);
                      }
                      return newLimit;
                    });
                  }}
                  progressPending={loading}
                />
              )}
            </Col>
            {/* <div className="d-flex align-items-center justify-content-center mt-3">
              <Button variant="primary" className="px-5">
                             t("viewMore")

              </Button>
            </div> */}
          </Row>
        </Container>
      </section>
      <BookingDateModal
        show={reviewmodalShow}
        t={t}
        onHide={() => setreviewmodalShow(false)}
        property_id={reviewPropertyId}
        bookingId={bookingIdd}
      />
    </React.Fragment>
  );
};

function BookingDateModal({ show, onHide, property_id, bookingId, t }) {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [isPosting, setisPosting] = useState(false);
  useEffect(() => {
    if (show) {
      setisPosting(false);
    }
  }, [show]);
  const postReview = async (propertyId, rating, description, bookingId) => {
    setisPosting(true);
    const response = await addReviewForProperty({
      propertyId,
      rating,
      description,
      bookingId: bookingId,
    });
    if (response?.status) {
      Swal.fire({
        icon: "success",
        text: t("reviewAddedSuccessfully"),
        // text: response?.message,
      });
      onHide();
      setTimeout(() => {
        window.location.reload()
      }, 1000);

    } else {
      Swal.fire({
        icon: "error",
        text: response?.message,
      });
    }
    setisPosting(false);
  };
  const handleStarClick = (clickedIndex) => {
    setRating(clickedIndex + 1);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body style={{ overflowY: "auto", padding: "20px" }}>
        <h3 className="text-center">{t("leaveReview")}</h3>
        <div
          className="star-rating mt-4"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div> {t("clickStarToRate")}</div>
          <div className="mt-2">
            {" "}
            {[...Array(5)].map((_, index) => (
              <span
                key={index}
                className={index < rating ? "star filled" : "star"}
                onClick={() => handleStarClick(index)}
                style={{ fontSize: "30px", cursor: "pointer" }}
              >
                ★
              </span>
            ))}
          </div>
        </div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>{t("review")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={review}
              onChange={(e) => setReview(e.target.value)}
              placeholder={t("enterReviewPlaceholder")}
            />
          </Form.Group>
          <Button
            variant="primary"
            type="button"
            disabled={!rating || isPosting}
            onClick={() => {
              postReview(property_id, rating, review, bookingId);
            }}
          >
            {isPosting ? t("posting") : t("postReview")}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default MyBookings;
